import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { getGiraUrl } from '@atlassian/jira-issue-fetch-services-common/src/services/issue-gira-data/index.tsx';
import type { BaseUrl } from '@atlassian/jira-shared-types/src/general.tsx';

export type GiraQuery<_R> = string;

const makeFetchClient = (baseUrl: BaseUrl) => ({
	query: <T,>({
		query,
		variables,
		signal,
		operationName,
	}: {
		query: GiraQuery<T>;
		variables: unknown;
		signal?: AbortSignal;
		operationName?: string;
	}): Promise<T> =>
		fetchJson(getGiraUrl(baseUrl, operationName), {
			method: 'POST',
			body: JSON.stringify({
				query,
				variables,
				operationName,
			}),
			signal,
		}),
});

let client: ReturnType<typeof makeFetchClient>;
export const getClient = (baseUrl: BaseUrl) => {
	if (!client) {
		client = makeFetchClient(baseUrl);
	}

	return client;
};
